module.exports = __webpack_public_path__ + "static/img/11.623b1a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/eng/11.png
// module id = wdya
// module chunks = 0